import React from 'react';
import { useEffect, useState, useRef } from "react";
import RedQuickLolomo from './RedQuickLoLoMo';
import './RedQuickLoLoList.scss'
import { RedQuickInfiniteScrollList } from './RedQuickInfiniteScrollList';
import { mobileAndTabletCheck } from './utility';
export default function RedQuickLoLoList(props: {
    lists: any[],
    sections: any[],
    itemsPerSlide?: number,
    itemContainerCls?: string,
    spaceHeight?: number,
    scaleActiveBy?: number
}) {
    const useFast = true;

    let [hoveredRow, setHoveredRow] = React.useState(null);
    let width = document.body.clientWidth;
    let itemsPerSlide = props.itemsPerSlide || 5;
    const itemWidth = +(width / itemsPerSlide).toFixed(2);
    const itemHeight = itemWidth * (9 / 16);
    return props?.lists?.map((array, index) => {
        if (useFast) {
            const scrollWidth = window.innerWidth;

            let updated_items = [...array].map((item: { color, component }, index: number) => {
                return <div className="card progressive-sizing" style={{
                    marginBottom: 10,
                    backgroundColor: 'transparent'
                }}>{item.component}</div>
            })

            return (
                <React.Fragment key={`list.${index}`}>
                    <h3 className="rq-lo-header">{props.sections[index] || `Films d'action`}</h3>
                    <div style={{
                        flex: 1, flexDirection: 'row',
                        flexWrap: 'wrap',
                        flexFlow: `row wrap`,
                        display: `flex`,
                        paddingLeft: '40px',
                        paddingRight: '40px',
                        padding: `38px`,
                        background: `transparent`
                    }}>
                        {updated_items}
                    </div>
                    <div style={{ height: props.spaceHeight || 40 }} />
                </React.Fragment>);
        }
        else if (mobileAndTabletCheck()) {
            // if mobile

            return (
                <React.Fragment key={`list.${index}`}>
                    <h3 className="rq-lo-header">{props.sections[index] || `Films d'action`}</h3>
                    <RedQuickInfiniteScrollList
                        itemsPerSlide={itemsPerSlide}
                        items={array} />
                    <div style={{ height: props.spaceHeight || 40 }} />
                </React.Fragment>)
        }
        return (
            <React.Fragment key={`list.${index}`}>
                <h3 className="rq-lo-header">{props.sections[index] || `Films d'action`}</h3>
                <RedQuickLolomo scale={true} backgroundColor="transparent"
                    scaleActiveBy={props.scaleActiveBy}
                    itemContainerCls={props.itemContainerCls}
                    hovered={hoveredRow === index}
                    itemsPerSlide={itemsPerSlide}
                    items={array} spaceBetween={2} onHover={() => {
                        setHoveredRow(index);
                    }} />
                <div style={{ height: props.spaceHeight || 40 }} />
            </React.Fragment>
        )
    });
}

export const useContainerDimensions = myRef => {
    const getDimensions = () => ({
        width: myRef.current.offsetWidth,
        height: myRef.current.offsetHeight
    })

    const [dimensions, setDimensions] = React.useState({ width: 0, height: 0 })

    React.useEffect(() => {
        const handleResize = () => {
            setDimensions(getDimensions())
        }

        if (myRef.current) {
            setDimensions(getDimensions())
        }

        window.addEventListener("resize", handleResize)

        return () => {
            window.removeEventListener("resize", handleResize)
        }
    }, [myRef])

    return dimensions;
};

export function useResizeObserver(targetRef) {
    const [contentRect, setContentRect] = useState({});
    const resizeObserver = useRef(null);

    useEffect(() => {
        if ("ResizeObserver" in self) {
            observe(ResizeObserver);
        } else {
            import("resize-observer-polyfill").then(observe);
        }

        function observe(ResizeObserver) {
            resizeObserver.current = new ResizeObserver(entries => {
                if (entries) {
                    setContentRect(() => entries[0].contentRect);
                }
            });
            if (targetRef.current) {
                resizeObserver.current.observe(targetRef.current);
            }
        }

        return disconnect;
    }, [targetRef, targetRef?.current?.clientWidth]);

    function disconnect() {
        if (resizeObserver.current) {
            resizeObserver.current.disconnect();
        }
    }

    return contentRect;
}

const defaultBreakpoints = { SM: 384, MD: 576, LG: 768, XL: 960 };

export function useContainerSize(targetRef, breakpoints = defaultBreakpoints) {
    const { width } = useResizeObserver(targetRef) as any;
    let sizes = [];

    for (const [sizeName, sizeValue] of Object.entries(defaultBreakpoints)) {
        if (width < sizeValue) {
            break;
        } else {
            sizes.push(sizeName);
        }
    }

    return {
        width,
        sizes
    };
}

